import React, { MouseEvent } from 'react';
import clsx from 'clsx';
import { HeaderLogoProps } from './HeaderLogo.types';
import { StyledHeaderLogo } from './HeaderLogo.styles';

export const HeaderLogo = (props: HeaderLogoProps) => {
  const { logoType, logoUrl = '', logoImageAltText = '', customClassName = '', isClickable = true } = props;
  const handleClick = (event: MouseEvent) => {
    if (!isClickable) {
      event.preventDefault();
    }
  };
  return (
    // TODO: See if there is a potential to reuse common icon component
    <StyledHeaderLogo
      data-component-name="m-ui-library-HeaderLogo"
      data-testid="ui-library-HeaderLogo"
      className={clsx('mr-0', customClassName)}
      onClick={event => handleClick(event)}
    >
      <a href={logoUrl} className={clsx(logoType || 't-program-logo-alt-color')} aria-label={logoImageAltText}>
        <span className="sr-only">{logoImageAltText}</span>
      </a>
    </StyledHeaderLogo>
  );
};
